import { getRequest } from './index';
import apiEndpoints from './apiEndpoints';

export const getSettingsRequest = () => getRequest(apiEndpoints.settings.get);
